import EmergencyInformationEmergency from './BCEmergencyInformationEmergency.vue'
import KeyAssignmentExtendedMenu from './BCKeyAssignmentExtendedMenu.vue'
import KeyAssignmentBLEKey from './BCKeyAssignmentBLEKey.vue'
import KeyAssignmentFront from './BCKeyAssignmentFront.vue'
import KeyAssignmentGeneral from './BCKeyAssignmentGeneral.vue'
import KeyAssignmentMenu from './BCKeyAssignmentMenu.vue'
import KeyAssignmentMicKey from './BCKeyAssignmentMicKey.vue'
import KeyAssignmentSideKey from './BCKeyAssignmentSideKey.vue'
import KeyAssignmentSuperLock from './BCKeyAssignmentSuperLock.vue'
import NetworkConfiguration from './BCNetworkConfiguration.vue'
import NetworkLTE from './BCNetworkLTE.vue'
import NetworkTone from './BCNetworkTone.vue'
import NetworkWiFi from './BCNetworkWiFi.vue'
import NetworkWiFiManagementList from './BCNetworkWiFiManagementList.vue'
import OptionalFeaturesBluetooth from './BCOptionalFeatureBluetooth.vue'
import OptionalFeaturesBattery from './BCOptionalFeaturesBattery.vue'
import OptionalFeaturesDataHold from './BCOptionalFeaturesDataHold.vue'
import OptionalFeaturesDisplay from './BCOptionalFeaturesDisplay.vue'
import OptionalFeaturesGPS from './BCOptionalFeaturesGPS.vue'
import OptionalFeaturesKeyFunction from './BCOptionalFeaturesKeyFunction.vue'
import OptionalFeaturesPassword from './BCOptionalFeaturesPassword.vue'
import OptionalFeaturesPowerOnMode from './BCOptionalFeaturesPowerOnMode.vue'
import OptionalFeaturesToneAudioAudioVolume from './BCOptionalFeaturesToneAudioAudioVolume.vue'
import OptionalFeaturesVOXExternalDevice from './BCOptionalFeaturesVOXExternalDevice.vue'
import ScanInformationGeneral from './BCScanInformationGeneral.vue'
import SelCallGeneral from './BCSelCallGeneral.vue'
import SelCallMessageList from './BCSelCallMessageList.vue'
import SelCallStatusList from './BCSelCallStatusList.vue'

export const componentsMap = {
    OptionalFeaturesDisplay,
    OptionalFeaturesPowerOnMode,
    OptionalFeaturesToneAudioAudioVolume,
    OptionalFeaturesGPS,
    OptionalFeaturesDataHold,
    OptionalFeaturesBluetooth,
    OptionalFeaturesVOXExternalDevice,
    OptionalFeaturesBattery,
    OptionalFeaturesKeyFunction,
    OptionalFeaturesPassword,
    KeyAssignmentGeneral,
    KeyAssignmentSideKey,
    KeyAssignmentFront,
    KeyAssignmentMicKey,
    KeyAssignmentMenu,
    KeyAssignmentExtendedMenu,
    KeyAssignmentSuperLock,
    KeyAssignmentBLEKey,
    NetworkConfiguration,
    ScanInformationGeneral,
    NetworkWiFiManagementList,
    NetworkWiFi,
    SelCallGeneral,
    EmergencyInformationEmergency,
    SelCallStatusList,
    SelCallMessageList,
    NetworkLTE,
    NetworkTone,
}
